<script lang="ts">
import {defineAsyncComponent, defineComponent, markRaw} from "vue";
  import FicheEtablissementAbstract from '@/generated/fiches/FicheEtablissementAbstract.vue';
  import {Extended} from "@/framework/base/classes/Schema.ts";
  import {FractionDsnTypes} from "@/generated/classes/FractionDsn.ts";
  import Adresse from "@/extend/classes/Adresse.ts";
  import {storeAdresse, storeEtablissement, storeSession} from "@/generated/stores";
  import UserProfile, {EnumProfile} from "@/framework/base/classes/UserProfile.ts";
  import Owner from "@/extend/classes/Owner.ts";
  import {ObjTypes} from "@/generated/classes/ObjTypes.ts";
  import {Fiches, Modules, Sections} from "@/generated/classes/AppSchema.ts";
  import {FwkButtons, RessourceFwkButton} from "@/ressources/globalRessources.ts";
  import Route from "@/extend/classes/Route.ts";
import Section from "@/framework/base/classes/Section.ts";
import {getSection} from "@/framework/base/helpers/ComponentFinder.ts";
import Etablissement from "@/extend/classes/Etablissement.ts";

export default defineComponent({
    extends: FicheEtablissementAbstract,
    components: {},
    data() {
      return {
        adresse: new Adresse(),
      }
    },
    computed: {
      selectedAdresse (): Adresse {
        if (this.adresse.id < 0) {
          storeAdresse.mAdresseDeleted(this.adresse.id);
        }
        this.updateAdresseOwner();
        return this.adresse;
      },
      isSalarie (): boolean {
        let res = false;
        const user = storeSession.connectedUser;
        if (user) {
          res = UserProfile.hasProfile(user, EnumProfile.salarie);
        }
        return res;
      },
      canAdd() : boolean {
        return this.etablissement.id < 0;
      },
      addLabel(): string {
        return RessourceFwkButton(FwkButtons.NEW_ETABLISSEMENT).label;
      },
      selectedEtablissement (): Etablissement {
        if (this.etablissement.id > 0) {
          return storeEtablissement.getEtablissement(this.etablissement.id);
        } else {
          return this.etablissement
        }
      },
    },
    methods: {
      getNewLabel() : string {
        return "Création d'un établissement";
      },
      addItem() : void {
        const route = new Route();
        const section  = new Section();
        const loader = getSection("SectionEtablissementIdentiteExtend");
        let component = null;
        if (loader) {
          component = markRaw(defineAsyncComponent(loader as any));
        }

        this.sectionComponent = component;
        this.sectionOpen = true;
      },
      updateAdresseOwner () {
        if (this.etablissement.adresseId == 0) {
          this.adresse = storeAdresse.createNewAdresse();
        } else {
          this.adresse = storeAdresse.getAdresse(this.etablissement.adresseId);
        }
        this.adresse.owner = new Owner()
        this.adresse.owner.objType = ObjTypes.CONTACT;
        this.adresse.owner.objId = this.etablissement.id;
      },
      isDisplayed (value: string): boolean {
        if (this.etablissement.id <= 0) {
          return false;
        }
        if ((!this.etablissement || this.etablissement.id < 0) && value == 'ETABLISSEMENT_IDENTITE_ABSTRACT') {
          this.setExtended(new Extended('ETABLISSEMENT_IDENTITE_ABSTRACT', this.fiche, true));
        }

        if (value == 'ETABLISSEMENT_REPRESENTANT_ABSTRACT') {
          return !this.isSalarie;
        }
        if (value == 'ETABLISSEMENT_GESTIONNAIRES_ABSTRACT') {
          return !this.isSalarie;
        }
        if (value == 'ETABLISSEMENT_JURIDIQUE_ABSTRACT') {
          return !this.isSalarie;
        }
        if (value == 'ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT') {
          return !this.isSalarie;
        }
        if (value == 'ETABLISSEMENT_PAYMENT_ABSTRACT') {
          return !this.isSalarie;
        }
        if (value == 'ETABLISSEMENT_DOCUMENT_ABSTRACT') {
          return !this.isSalarie;
        }
        if (value == 'ABONNEMENT') {
          return !this.isSalarie;
        }
        if (value == 'ETABLISSEMENT_CART_ABSTRACT') {
          return !this.isSalarie;
        }
        if (value == 'DEMANDE_ATTESTATION_ABSTRACT') {
          return !this.isSalarie;
        }
        
        if (value == 'ETABLISSEMENT_APPRENTI_ABSTRACT') {
          let res = false;
          if (!this.isSalarie) {
            this.etablissement.fractionDsn.forEach((fraction) => {
              if (fraction.type == FractionDsnTypes.PERMANENT || fraction.type == FractionDsnTypes.MIXTE) {
                res = true;
              }
            });
          }
          return res;
        }
        return true;
      }
    },
})
</script>
